import { ReactElement, ReactNode } from 'react';
import Modal from 'react-modal';
import { UIButton, UIButtonProps } from '../ui-button';
import styles from './ui-modal.module.scss';
import { UIText, UITextProps } from '../ui-text';
import { UIModalZIndex } from '../z-index';

export type UIModalProps = {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    small?: boolean;
};

export function UIModal(props: UIModalProps): ReactElement {
    const { isOpen, onClose, children, small = false } = props;

    const classNames = [styles.container];
    if (small) {
        classNames.push(styles.containerSmall);
    } else {
        classNames.push(styles.containerMedium);
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className={classNames.join(' ')}
            style={{
                overlay: {
                    zIndex: UIModalZIndex,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }
            }}
        >
            {children}
        </Modal>
    );
}

export type UIModalHeaderProps = {
    title: string;
    titleProps?: UITextProps;
    subtitle?: string;
    subtitleProps?: UITextProps;
};
export function UIModalHeader(props: UIModalHeaderProps): ReactElement {
    const { title, titleProps, subtitle, subtitleProps } = props;

    return (
        <div className={styles.header}>
            <UIText variant="h2" bold {...titleProps}>
                {title}
            </UIText>
            <UIText {...subtitleProps}>{subtitle}</UIText>
        </div>
    );
}

export type UIModalContentProps = {
    children: ReactNode;
};
export function UIModalContent(props: UIModalContentProps): ReactElement {
    const { children } = props;

    return <div className={styles.content}>{children}</div>;
}

export type UIModalFooterProps = {
    actions: UIButtonProps[];
};
export function UIModalFooter(props: UIModalFooterProps): ReactElement {
    const { actions } = props;

    return (
        <div className={styles.footer}>
            {actions.map((actionProps, index) => (
                <UIButton key={index} {...actionProps} />
            ))}
        </div>
    );
}
